import { useCurrentSkyview } from './useCurrentSkyview'
import { useSkyviewDaily } from './useSkyviewDaily'

export const skyview = {
  currentSkyview: useCurrentSkyview,
  skyviewDaily: useSkyviewDaily,
}
